import { render, staticRenderFns } from "./VepContainer.vue?vue&type=template&id=e209984e&scoped=true&"
import script from "./VepContainer.vue?vue&type=script&lang=ts&"
export * from "./VepContainer.vue?vue&type=script&lang=ts&"
import style0 from "./VepContainer.vue?vue&type=style&index=0&id=e209984e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e209984e",
  null
  
)

export default component.exports